import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingGiftCardError = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="165"
        height="114"
        viewBox="0 0 165 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <rect x="0.5" width="149.996" height="100" rx="12" fill="#E6E6E6" />
        <rect x="12.4961" width="35" height="37.8193" fill="#F9F9F9" />
        <rect
          x="65.4961"
          y="73.6992"
          width="75"
          height="15.5156"
          rx="4"
          fill="#F9F9F9"
        />
        <rect
          x="12.5"
          y="56.2441"
          width="128"
          height="15.5156"
          rx="4"
          fill="#F9F9F9"
        />
        <path
          d="M137.924 111.051C151.064 111.051 161.848 100.702 161.848 87.7755C161.848 74.8489 151.064 64.5 137.924 64.5C124.784 64.5 114 74.8489 114 87.7755C114 100.702 124.784 111.051 137.924 111.051Z"
          fill="#E90200"
          stroke="white"
          strokeWidth="5"
        />
        <path
          d="M146.28 78.6368L128.5 96.1661M129.466 78.6368L147.246 96.1661"
          stroke="#F2F7FF"
          strokeWidth="5"
          strokeMiterlimit="10"
        />
      </svg>
    );
  }
);
export default BillingGiftCardError;
